module.exports = __webpack_public_path__ + "img/module9.8503c9e.png";